import { Directive, ElementRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from './auth-service.service';

@Directive({
  selector: '[userHasRole]'
})
export class HasRoleDirective {
  constructor(private authService: AuthService, private el: ElementRef, private viewContainer: ViewContainerRef) {}    
  @Input() set userHasRole(roleName : any){      
      if( Array.isArray(roleName)){
        if(!this.authService.userHasRole(roleName)){
          this.el.nativeElement.style.display = "none";
        }
      } else {      
        if(!this.authService.userHasRole([roleName])){
            this.el.nativeElement.style.display = "none";
        }
      }
  }

}
